<div class="zoom__overlay"></div>
<div class="zoom">
    <div class="zoom__image" [ngStyle]="getStyle()"></div>
    <a class="zoom__close" (click)="closeModal($event)"><span class="ico-remove"></span></a>
</div>
